'use client';

import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';
import { cn } from '@zealot/ui/lib/utils';

const Collapsible = ({ className, ...props }: CollapsiblePrimitive.Root.Props) => {
  return <CollapsiblePrimitive.Root data-slot="collapsible" className={className} {...props} />;
};

const CollapsibleTrigger = ({ className, ...props }: CollapsiblePrimitive.Trigger.Props) => {
  return <CollapsiblePrimitive.Trigger data-slot="collapsible-trigger" className={className} {...props} />;
};

const CollapsibleContent = ({ className, ...props }: CollapsiblePrimitive.Panel.Props) => {
  return (
    <CollapsiblePrimitive.Panel
      data-slot="collapsible-content"
      className={cn('overflow-hidden data-closed:animate-collapsible-up data-open:animate-collapsible-down', className)}
      {...props}
    />
  );
};

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
